angular.module( 'acme.view.application.pos.create.settings', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.pos.create.settings.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var posCreateSettings = {
        name: 'application.pos.create.settings',
        url: '/settings',
        views: {
          "subview-main": {
            controller: 'PosCreateSettingsController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/pos/create/settings/settings.tpl.html'
          }
        },
        data: {
          pageTitle: 'Point of Sale Configurator'
        }
      },
      posEditSettings = {
        name: 'application.pos.edit.settings',
        url: '/settings',
        views: {
          "subview-main": {
            controller: 'PosCreateSettingsController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/pos/create/settings/settings.tpl.html'
          }
        },
        data: {
          pageTitle: 'Point of Sale Configurator'
        }
      };

    $stateProvider
      .state(posCreateSettings)
      .state(posEditSettings);
});
